export interface UserConfig {
  leftSideContainerWidth: number;
  framesHeight: number;
  rightSideContainerWidth: number;
  /** When true, canvas bottom shortcut hint bar shows all keys; when false, only the expand toggle (Lucide chevron). */
  canvasHintsExpanded?: boolean;
}

export const defaultUserConfig: UserConfig = {
  leftSideContainerWidth: 300,
  rightSideContainerWidth: 375,
  framesHeight: 200,
  canvasHintsExpanded: false,
};